import {OfferClickManager} from '../../offer/offerClickManager';
import {CommentLoader} from '../../offer/commentLoader';
import {setToList, slideDown} from '../../../../application/helpers';
import {ConfigProvider} from '../../../../application/config/configProvider';
import {SubscriptionForm} from '../../subscription/subscriptionForm';
import {PaginatedUserOffers} from '../../offer/contentLoaders/paginatedUserOffers';
import OfferViewFacade from '../../offer/offerViewFacade';

class ShopOffers
{
    constructor(contentElement) {
        this.container = contentElement;
        this.extensionBlock = this.container.querySelector('[data-block="extension"]');
        this.externalProductsBlock = this.container.querySelector('[data-block="external-products"]');
        this.cashbackBlock = this.container.querySelector('[data-block="cashback"]');
        this.promoAdvertisementBlock = this.container.querySelector('[data-block="promo-advertisement"]');
        this.subscribeBlock = this.container.querySelector('[data-block="subscribe"]');

        this.extendedOffersSection = new PaginatedUserOffers(this.container.querySelector('[data-section="extended-offers"]'));
        this.userOffersSection = new PaginatedUserOffers(this.container.querySelector('[data-section="user-offers"]'));

        OfferClickManager.init(this.container);
        CommentLoader.initToggleButtons(this.container);
        OfferViewFacade.notifyAboutAllAvailable(this.container);

        this.initFilter();

        this.moveCashbackBlock();
        this.movePromoAdvertisementBlock();
        this.toggleExtensionBlock(true);
        this.toggleEternalProductsBlock(true);
        this.initSubscribeBlock();
    }

    initFilter() {
        this.filterType = 'all';
        this.currentOrder = 'bestOrder';

        Array.from(this.container.querySelectorAll('[data-list="offer"]')).forEach((element, index) => {
            element.dataset.bestOrder = String(index);
        });

        Array.from(this.container.querySelectorAll('[data-offers="filter"]')).forEach((element) => {
            element.addEventListener('change', (event) => {
                let offerSections = this.container.querySelectorAll('[data-offers="section"]:not([data-section="similar"])'),
                    target = event.currentTarget;

                this.filterType = target.value;

                if (this.filterType === 'first_order') {
                    this.sortOffers('isFirstOrder', 'desc');
                    this.currentOrder = 'isFirstOrder';
                } else if (this.currentOrder !== 'bestSort') {
                    this.sortOffers('bestOrder', 'asc');
                    this.currentOrder = 'bestOrder';
                }

                Array.from(offerSections).forEach((offerSection) => {
                    let codes = offerSection.querySelectorAll('[data-list="offer"][data-is-share="0"]'),
                        shares = offerSection.querySelectorAll('[data-list="offer"][data-is-share="1"]'),
                        sharesNotFirstOrder = offerSection.querySelectorAll('[data-list="offer"][data-is-share="1"]:not([data-is-first-order="1"])'),
                        firstOrder = offerSection.querySelectorAll('[data-list="offer"][data-is-first-order="1"]'),
                        notFirstOrder = offerSection.querySelectorAll('[data-list="offer"][data-is-first-order="0"]');

                    if (this.filterType === 'codes') {
                        Array.from(codes).forEach((element) => element.classList.remove('is-none'));
                        Array.from(shares).forEach((element) => element.classList.add('is-none'));
                    } else if (this.filterType === 'first_order') {
                        let lang = ConfigProvider.get('lang');

                        if (lang === 'ua') {
                            Array.from(firstOrder).forEach((element) => element.classList.remove('is-none'));
                            Array.from(notFirstOrder).forEach((element) => element.classList.add('is-none'));
                        } else {
                            Array.from(codes).forEach((element) => element.classList.remove('is-none'));
                            Array.from(sharesNotFirstOrder).forEach((element) => element.classList.add('is-none'));
                        }
                    } else if (this.filterType === 'deals') {
                        Array.from(codes).forEach((element) => element.classList.add('is-none'));
                        Array.from(shares).forEach((element) => element.classList.remove('is-none'));
                    } else if (this.filterType === 'not_first_order') {
                        Array.from(firstOrder).forEach((element) => element.classList.add('is-none'));
                        Array.from(notFirstOrder).forEach((element) => element.classList.remove('is-none'));
                    } else {
                        Array.from(codes).forEach((element) => element.classList.remove('is-none'));
                        Array.from(shares).forEach((element) => element.classList.remove('is-none'));
                        Array.from(firstOrder).forEach((element) => element.classList.remove('is-none'));
                        Array.from(notFirstOrder).forEach((element) => element.classList.remove('is-none'));
                    }

                    if (offerSection.querySelectorAll('[data-list="offer"]:not(.is-none)').length) {
                        offerSection.classList.remove('is-none');
                    } else {
                        offerSection.classList.add('is-none');
                    }
                });

                this.togglePromoBlock(this.filterType === 'all');
                this.toggleExtensionBlock(this.filterType === 'all');
                this.toggleEternalProductsBlock(this.filterType === 'all');
                this.toggleSubscribeBlock(this.filterType === 'all');

                this.filterType === 'all' ? this.userOffersSection.showButtonMore() : this.userOffersSection.hideButtonMore();
                this.filterType === 'all' ? this.extendedOffersSection.showButtonMore() : this.extendedOffersSection.hideButtonMore();
            });
        });
    }

    sortOffers(sortingBy, sortingDir) {
        let offerSections = this.container.querySelectorAll('[data-offers="section"]:not([data-section="similar"])');

        Array.from(offerSections).forEach((sectionElement) => {
            let offers = sectionElement.querySelectorAll('[data-list="offer"]');

            offers = Array.from(offers).sort((firstElement, secondElement) => {
                let firstValue = Number(firstElement.dataset[sortingBy]),
                    secondValue = Number(secondElement.dataset[sortingBy]);

                if (firstValue > secondValue) {
                    return sortingDir === 'desc' ? -1 : 1;
                }

                if (firstValue < secondValue) {
                    return sortingDir === 'desc' ? 1 : -1;
                }

                return 0;
            });

            Array.from(offers).forEach((offer) => offer.parentNode.appendChild(offer));
        });
    }

    moveExtensionBlock() {
        if (this.extensionBlock) {
            let offerElements = document.querySelectorAll('[data-shop="offers"] [data-list="offer"]');
            setToList(offerElements, this.extensionBlock, ConfigProvider.get('shop_page_extension_index'));
        }
    }

    moveExternalProductsBlock() {
        if (this.externalProductsBlock) {
            let offerElements = document.querySelectorAll('[data-shop="offers"] [data-list="offer"]');
            setToList(offerElements, this.externalProductsBlock, ConfigProvider.get('shop_page_external_products_index'));
        }
    }

    moveCashbackBlock() {
        if (this.cashbackBlock) {
            let offerElements = document.querySelectorAll('[data-shop="offers"] [data-list="offer"]');
            setToList(offerElements, this.cashbackBlock, ConfigProvider.get('shop_page_cashback_index') - 1);
        }
    }

    movePromoAdvertisementBlock() {
        if (this.promoAdvertisementBlock) {
            let offerElements = document.querySelectorAll('[data-shop="offers"] [data-list="offer"]');
            setToList(offerElements, this.promoAdvertisementBlock, ConfigProvider.get('promo_advertisement_index') - 1);
        }
    }

    moveSubscriptionBlock() {
        if (this.subscribeBlock) {
            let offerElements = document.querySelectorAll('[data-shop="offers"] [data-list="offer"]');
            let index = this.subscribeBlock.dataset.index ? Number(this.subscribeBlock.dataset.index) : ConfigProvider.get('subscribe_block_index');

            setToList(offerElements, this.subscribeBlock, index - 1);
        }
    }

    /** @param {Boolean} status */
    toggleExtensionBlock(status) {
        if (this.extensionBlock) {
            if (status) {
                this.moveExtensionBlock();
                this.moveCashbackBlock();
                this.extensionBlock.classList.remove('is-none');
                slideDown(this.extensionBlock);
            } else {
                this.extensionBlock.classList.add('is-none');
            }
        }
    }

    /** @param {Boolean} status */
    togglePromoBlock(status) {
        if (this.promoAdvertisementBlock) {
            if (status) {
                this.movePromoAdvertisementBlock();
                this.promoAdvertisementBlock.classList.remove('is-none');
                slideDown(this.promoAdvertisementBlock);
            } else {
                this.promoAdvertisementBlock.classList.add('is-none');
            }
        }
    }

    /** @param {Boolean} status */
    toggleSubscribeBlock(status) {
        if (this.subscribeBlock) {
            this.subscribeBlock.classList.toggle('is-none', !status)

            if (status) {
                this.moveSubscriptionBlock();
            }
        }


    }

    /** @param {Boolean} status */
    toggleEternalProductsBlock(status) {
        if (this.externalProductsBlock) {
            if (status) {
                this.moveExternalProductsBlock();
                this.moveCashbackBlock();
                this.externalProductsBlock.classList.remove('is-none');
                slideDown(this.externalProductsBlock);
            } else {
                this.externalProductsBlock.classList.add('is-none');
            }
        }
    }

    initSubscribeBlock() {
        if (this.subscribeBlock) {
            new SubscriptionForm(document.querySelector('[data-subsctiption="form"]'));
        }

        this.moveSubscriptionBlock();
    }
}

export {ShopOffers};
